<template>
  <div id="moderation">
    <v-container>
      <v-card class="rounded-xl" elevation="7">
        <v-tabs class="rounded-xl" color="#007aff">
          <v-tab>
            <v-icon left> mdi-flag</v-icon>
            Reports
          </v-tab>
          <v-tab>
            <v-icon left> mdi-plus</v-icon>
            Invites
          </v-tab>
          <v-tab-item class="rounded-xl">
            <v-card>
              <v-container>
                <v-row>
                  <v-col v-for="report in reports.reports" :key="report.id">
                    <v-card class="text-center justify-center" elevation="24">
                      <v-card-title
                        v-if="!report.upload"
                        class="justify-center text-h5"
                        >{{ report.reportedUser.username }} (User)
                      </v-card-title>
                      <v-card-title
                        v-if="report.upload"
                        class="justify-center text-h5"
                        >{{ report.upload.name }} (Item)
                      </v-card-title>
                      <p>Reason: {{ report.message }}</p>
                      <v-tooltip
                        v-if="report.reportedUser"
                        color="hoverCard"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <p class="justify-center" v-on="on">
                            Reported User:
                            <v-icon
                              v-if="report.reportedUser.administrator"
                              aria-hidden="false"
                              color="red"
                            >
                              mdi-gavel
                            </v-icon>
                            <v-icon
                              v-if="
                                report.reportedUser.plan.internalName !==
                                  'FREE' &&
                                !report.reportedUser.administrator &&
                                !report.reportedUser.moderator
                              "
                              :color="report.reportedUser.plan.color"
                              aria-hidden="false"
                            >
                              mdi-plus
                            </v-icon>
                            <span
                              v-if="
                                report.reportedUser.beta &&
                                report.reportedUser.plan.internalName ===
                                  'FREE' &&
                                !report.reportedUser.administrator &&
                                !report.reportedUser.moderator
                              "
                              style="color: #764bc4"
                              >β</span
                            >
                            <v-icon
                              v-if="
                                report.reportedUser.moderator &&
                                !report.reportedUser.administrator
                              "
                              aria-hidden="false"
                              color="green"
                            >
                              mdi-shield
                            </v-icon>
                            <router-link
                              :to="'/u/' + report.reportedUser.username"
                              >{{ report.reportedUser.username }}
                            </router-link>
                          </p>
                        </template>
                        <div class="text-center">
                          <p class="text-h6">
                            <v-avatar
                              v-if="report.reportedUser.avatar"
                              :src="'/i/' + report.reportedUser.avatar"
                              align="center"
                              class="text-center"
                              height="40"
                              width="40"
                            >
                              <img
                                v-if="report.reportedUser.avatar"
                                :src="'/i/' + report.reportedUser.avatar"
                              />
                            </v-avatar>
                            <v-avatar
                              v-if="!report.reportedUser.user.avatar"
                              :src="
                                '/api/v1/userutils/identicon/' +
                                report.reportedUser.user.username
                              "
                              align="center"
                              class="text-center justify-center"
                              justify="center"
                              size="40"
                            >
                              <img
                                v-if="!report.reportedUser.user.avatar"
                                :src="
                                  '/api/v1/userutils/identicon/' +
                                  report.reportedUser.user.username
                                "
                              /> </v-avatar
                            >&nbsp;{{ report.reportedUser.username }} (<span
                              style="
                                font-weight: 500;
                                background: -webkit-linear-gradient(
                                  #0179f3,
                                  #0190ea
                                );
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                              "
                              >{{ report.reportedUser.id }}</span
                            >)
                          </p>
                          <v-chip
                            v-if="report.reportedUser.administrator"
                            class="ma-1"
                            color="red"
                            text-color="white"
                          >
                            <v-icon> mdi-gavel</v-icon>&nbsp;Administrator
                          </v-chip>
                          <v-chip
                            v-if="report.reportedUser.moderator"
                            class="ma-1"
                            color="green"
                            text-color="white"
                          >
                            <v-icon> mdi-shield</v-icon>&nbsp;Moderator
                          </v-chip>
                          <v-chip
                            v-if="
                              report.reportedUser.plan.internalName !== 'FREE'
                            "
                            :color="report.reportedUser.plan.color"
                            class="ma-1"
                            text-color="white"
                          >
                            <v-icon>
                              {{ report.reportedUser.plan.icon }} </v-icon
                            >&nbsp;
                            {{ report.reportedUser.plan.name }}
                          </v-chip>
                          <v-chip
                            v-if="report.reportedUser.beta"
                            class="ma-1"
                            color="deep-purple"
                            text-color="white"
                          >
                            β Beta
                          </v-chip>
                        </div>
                      </v-tooltip>
                      <v-tooltip
                        v-if="report.reportedByUser"
                        color="hoverCard"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <p class="justify-center" v-on="on">
                            Reported By User:
                            <v-icon
                              v-if="report.reportedByUser.administrator"
                              aria-hidden="false"
                              color="red"
                            >
                              mdi-gavel
                            </v-icon>
                            <v-icon
                              v-if="
                                report.reportedByUser.plan.internalName !==
                                  'FREE' &&
                                !report.reportedByUser.administrator &&
                                !report.reportedByUser.moderator
                              "
                              :color="report.reportedByUser.plan.color"
                              aria-hidden="false"
                            >
                              {{ report.reportedUser.plan.icon }}
                            </v-icon>
                            <span
                              v-if="
                                report.reportedByUser.beta &&
                                report.reportedByUser.plan.internalName ===
                                  'FREE' &&
                                !report.reportedByUser.administrator &&
                                !report.reportedByUser.moderator
                              "
                              style="color: #764bc4"
                              >β</span
                            >
                            <v-icon
                              v-if="
                                report.reportedByUser.moderator &&
                                !report.reportedByUser.administrator
                              "
                              aria-hidden="false"
                              color="green"
                            >
                              mdi-shield
                            </v-icon>
                            <router-link
                              :to="'/u/' + report.reportedByUser.username"
                              >{{ report.reportedByUser.username }}
                            </router-link>
                          </p>
                        </template>
                        <div class="text-center">
                          <p class="text-h6">
                            <v-avatar
                              v-if="report.reportedByUser.avatar"
                              :src="'/i/' + report.reportedByUser.avatar"
                              align="center"
                              class="text-center"
                              height="40"
                              width="40"
                            >
                              <img
                                v-if="report.reportedByUser.avatar"
                                :src="'/i/' + report.reportedByUser.avatar"
                              />
                            </v-avatar>
                            <v-avatar
                              v-if="!report.reportedByUser.avatar"
                              :color="report.reportedByUser.openGraphColor"
                              class="justify-center"
                              width="20"
                            >
                              <span class="white--text text-h6">{{
                                report.reportedByUser.username.charAt(0)
                              }}</span></v-avatar
                            >&nbsp;{{ report.reportedByUser.username }} (<span
                              style="
                                font-weight: 500;
                                background: -webkit-linear-gradient(
                                  #0179f3,
                                  #0190ea
                                );
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                              "
                              >{{ report.reportedByUser.id }}</span
                            >)
                          </p>
                          <v-chip
                            v-if="report.reportedByUser.administrator"
                            class="ma-1"
                            color="red"
                            text-color="white"
                          >
                            <v-icon> mdi-gavel</v-icon>&nbsp;Administrator
                          </v-chip>
                          <v-chip
                            v-if="report.reportedByUser.moderator"
                            class="ma-1"
                            color="green"
                            text-color="white"
                          >
                            <v-icon> mdi-shield</v-icon>&nbsp;Moderator
                          </v-chip>
                          <v-chip
                            v-if="
                              report.reportedByUser.plan.internalName !== 'FREE'
                            "
                            :color="report.reportedByUser.plan.color"
                            class="ma-1"
                            text-color="white"
                          >
                            <v-icon>
                              {{ report.reportedByUser.plan.icon }} </v-icon
                            >&nbsp;
                            {{ report.reportedByUser.plan.name }}
                          </v-chip>
                          <v-chip
                            v-if="report.reportedByUser.beta"
                            class="ma-1"
                            color="deep-purple"
                            text-color="white"
                          >
                            β Beta
                          </v-chip>
                        </div>
                      </v-tooltip>
                      <v-img
                        v-if="report.upload"
                        :src="'/i/' + report.upload.attachment"
                        contain
                        height="220"
                      ></v-img>
                      <v-card-actions class="text-center justify-center">
                        <v-chip
                          class="mr-2"
                          color="red"
                          text-color="white"
                          @click="actOnReport(report, 'delete')"
                        >
                          <v-icon left> mdi-delete</v-icon>
                          Delete Item
                        </v-chip>
                        <v-chip
                          class="mr-2"
                          color="red"
                          text-color="white"
                          @click="actOnReport(report, 'ban')"
                        >
                          <v-icon left> mdi-gavel</v-icon>
                          Delete Item, Ban User
                        </v-chip>
                        <v-chip
                          class="mr-2"
                          color="green"
                          text-color="white"
                          @click="actOnReport(report, 'dismiss')"
                        >
                          <v-icon left> mdi-check</v-icon>
                          Delete Report
                        </v-chip>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <p>Grant user an invite.</p>
              <v-text-field
                class="rounded-xl"
                v-model="invites.username"
                :outlined="!$store.state.site.whitelabel"
                label="Username"
              ></v-text-field>
              <v-btn
                class="rounded-xl"
                :disabled="!invites.username"
                :loading="invites.loadingUser"
                @click="doInviteEntitlementForUser(1)"
                >Grant
              </v-btn>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import dayjs from "dayjs"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat)

export default {
  name: "Moderation",
  data() {
    return {
      invites: {
        username: "",
        loading: false,
        loadingUser: false
      },
      reports: {
        pager: [],
        reports: [],
        page: 1
      }
    }
  },
  methods: {
    doInviteEntitlementForUser(count) {
      this.invites.loadingUser = true
      this.axios
        .put("/api/v1/moderation/invite/wave/" + this.invites.username, {
          count
        })
        .then(() => {
          this.invites.loadingUser = false
        })
        .catch((e) => {
          this.invites.loadingUser = false
          AjaxErrorHandler(this.$store)(e)
        })
    },
    actOnReport(report, type) {
      if (report.upload) {
        this.axios
          .post("/api/v1/moderation/reports/act", {
            type: type,
            userId: report.reportedUser.id,
            uploadId: report.upload.id,
            reportId: report.id
          })
          .then(() => {
            this.getReports()
          })
      } else {
        this.axios
          .post("/api/v1/moderation/reports/act", {
            type: type,
            userId: report.reportedUser.id,
            reportId: report.id,
            uploadId: 0
          })
          .then(() => {
            this.getReports()
          })
          .catch((e) => {
            AjaxErrorHandler(this.$store)(e)
          })
      }
    },
    dayjs(params) {
      return dayjs(params)
    },
    getReports() {
      this.axios
        .get("/api/v1/moderation/reports/list/" + this.reports.page)
        .then((res) => {
          this.reports.reports = res.data.reportArray
          this.reports.pager = res.data.pager
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getReports()
  }
}
</script>

<style scoped></style>
